import { redirectToDashboard } from '../';

import Login from '../pages/login';
import LoginForm from '../pages/login/form';
import New from '../pages/new';
import Forgot from '../pages/forgot';


export default [
  {
    onEnter: redirectToDashboard,
    path: '/',
  },
  {
    onEnter: redirectToDashboard,
    path: 'login',
    getComponent(nextState, cb) {
      require.ensure([], () => {
        cb(null, Login);
      });
    },
  },
  {
    onEnter: redirectToDashboard,
    path: 'login/form',
    getComponent(nextState, cb) {
      require.ensure([], () => {
        cb(null, LoginForm);
      });
    },
  },
  {
    path: 'login/new',
    getComponent(nextState, callback) {
      callback(null, New);
    },
  },
  {
    path: 'login/forgot',
    getComponent(nextState, cb) {
      require.ensure([], () => {
        cb(null, Forgot);
      });
    },
  },
];



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/routes/index.js
 **/